/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { PaginationContainer } from './css';

const PaginationControls = ({ currentPage, totalPages, setCurrentPageFn }) => {
  const handlePageFirst = () => {
    setCurrentPageFn(1);
  };

  const handlePagePrevious = () => {
    if (currentPage === 1) {
      return;
    }

    setCurrentPageFn(currentPage - 1);
  };

  const handlePageNext = () => {
    if (currentPage === totalPages) {
      return;
    }

    setCurrentPageFn(currentPage + 1);
  };

  const handlePageLast = () => {
    setCurrentPageFn(totalPages);
  };

  const handleClick = (e) => {
    setCurrentPageFn(Number(e.target.id));
  };

  const getPaginationRange = ({ currentPage, totalPages }) => {
    // Constants...
    const START_PAGE = 1;
    const DEFAULT_RANGE = 5;

    // Initializations...
    let range = DEFAULT_RANGE;

    if (range > totalPages) {
      range = totalPages;
    }

    let start = currentPage - Math.floor(range / 2);
    start = Math.max(start, START_PAGE);
    start = Math.min(start, START_PAGE + totalPages - range);

    return Array.from(
      { length: range },
      (element, index) => start + index,
    );
  };

  const pages = getPaginationRange({ currentPage, totalPages });

  return (
    <PaginationContainer>
      <ul>
        <li onClick={handlePageFirst} className={currentPage === 1 ? 'disabled' : ''}>
          <div className="firstArrow">
            {t('First')}
          </div>
        </li>
        <li onClick={handlePagePrevious} className={currentPage === 1 ? 'disabled' : ''}>
          <div className="prevArrow">
            {t('Previous')}
          </div>
        </li>

        {
          pages.map((page) => (
            <li
              key={page}
              id={page}
              onClick={handleClick}
              className={currentPage === page ? 'active number' : 'number'}
            >
              {page}
            </li>
          ))
        }

        <li onClick={handlePageNext} className={currentPage === totalPages ? 'disabled' : ''}>
          <div className="nextArrow">
            {t('Next')}
          </div>
        </li>
        <li onClick={handlePageLast} className={currentPage === totalPages ? 'disabled' : ''}>
          <div className="lastArrow">
            {t('Last')}
          </div>
        </li>
      </ul>
    </PaginationContainer>
  );
};

PaginationControls.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  setCurrentPageFn: PropTypes.func,
};

export default PaginationControls;
